'use client'

import { Radio } from 'antd'
import { SBDynamicFormInput, SBDynamicFormInputProps } from './types'

const SBDynamicFormInputRadio: SBDynamicFormInput = ({
  item,
  ...rest
}: SBDynamicFormInputProps) => {
  return (
    <Radio.Group
      {...rest}
      options={item.options?.map((option) => ({
        value: option.id,
        label: option.label,
      }))}
    />
  )
}

export { SBDynamicFormInputRadio }
